// Função para rastrear eventos do Facebook Pixel
export const trackContactEvent = () => {
  if (window.fbq) {
    window.fbq('track', 'Contact');
  }
};

// Declaração global para o fbq
declare global {
  interface Window {
    fbq: any;
  }
}